var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_450_1732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.86994 15.2549C8.46236 15.2549 10.1092 15.2549 10.1092 15.2549C10.1092 15.2549 11.7558 15.2549 12.3486 15.2549C12.9407 15.2549 13.2095 14.3934 12.8668 13.7845C12.6087 13.3256 12.1858 12.8053 11.4975 12.5098C11.1035 12.7856 10.6249 12.9478 10.1092 12.9478C9.59301 12.9478 9.11503 12.7856 8.72104 12.5098C8.03248 12.8053 7.6098 13.3256 7.35141 13.7845C7.009 14.3934 7.27753 15.2549 7.86994 15.2549Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1094 12.3713C11.1209 12.3713 11.9405 11.5521 11.9405 10.5404V10.1018C11.9405 9.09026 11.121 8.27045 10.1094 8.27045C9.09777 8.27045 8.27795 9.09026 8.27795 10.1018V10.5404C8.27795 11.5521 9.09777 12.3713 10.1094 12.3713Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5471 2.20264H12.7791V2.79592C12.7791 3.94078 11.8475 4.87243 10.7026 4.87243H9.51603C8.37118 4.87243 7.43953 3.94078 7.43953 2.79592V2.20264H4.67154C3.74277 2.20264 2.98987 2.95554 2.98987 3.88428V17.133C2.98987 18.0617 3.74277 18.8147 4.67154 18.8147H15.5471C16.4758 18.8147 17.2287 18.0617 17.2287 17.133V3.88428C17.2288 2.95554 16.4759 2.20264 15.5471 2.20264ZM15.4489 17.0348H4.76973V5.61402H15.4489V17.0348Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.51593 4.27911H10.7025C11.5204 4.27911 12.1857 3.6137 12.1857 2.79589V1.60932C12.1857 0.791512 11.5203 0.126099 10.7025 0.126099H9.51593C8.69813 0.126099 8.03271 0.791512 8.03271 1.60932V2.79589C8.03271 3.61366 8.69813 4.27911 9.51593 4.27911ZM9.21929 1.60932C9.21929 1.44536 9.35197 1.31267 9.51593 1.31267H10.7025C10.8665 1.31267 10.9992 1.44536 10.9992 1.60932V2.20261C10.9992 2.36657 10.8665 2.49925 10.7025 2.49925H9.51593C9.35197 2.49925 9.21929 2.36657 9.21929 2.20261V1.60932Z",
    fill: "#E5E5E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_450_1732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6885,
    height: 18.6885,
    fill: "white",
    transform: "translate(0.765015 0.126099)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/employees.0f24ccc4f99e1912f8650d417146c8df.svg";
export { ForwardRef as ReactComponent };